<iframe
  *ngIf="iframeUrl$ | async as url"
  class="mu_chat__frame"
  [src]="url"
  [title]="'shared.chatPanelTitle' | translate"
  referrerpolicy="no-referrer"
></iframe>
